import script from "./OAcordeaoProjetos.vue?vue&type=script&lang=ts&setup=true"
export * from "./OAcordeaoProjetos.vue?vue&type=script&lang=ts&setup=true"

import "./OAcordeaoProjetos.vue?vue&type=style&index=0&id=fbbea1b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbbea1b8"]])

export default __exports__